const csrfCookie = () => {
  const csrfCookie = document.cookie.split('; ').find(row => row.startsWith('_csrf__branded='));
    if (!csrfCookie) {
      throw new Error('CSRF token not found in cookies');
    }
  return csrfCookie.split('=')[1];
};

export default csrfCookie;